var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenInFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3H14C13.4561 3 13 3.45614 13 4C13 4.54386 13.4561 5 14 5H20C20.5439 5 21 4.54386 21 4C21 3.45614 20.5439 3 20 3ZM21 10V4C21 3.45614 20.5439 3 20 3C19.4561 3 19 3.45614 19 4V10C19 10.5439 19.4561 11 20 11C20.5439 11 21 10.5439 21 10ZM14.7018 10.7018L20.7018 4.70175C20.8947 4.52632 21 4.2807 21 4C21 3.45614 20.5439 3 20 3C19.7193 3 19.4737 3.10526 19.2982 3.29825L13.2982 9.29825C13.1053 9.47368 13 9.7193 13 10C13 10.5439 13.4561 11 14 11C14.2807 11 14.5263 10.8947 14.7018 10.7018ZM10 19H4C3.45614 19 3 19.4561 3 20C3 20.5439 3.45614 21 4 21H10C10.5439 21 11 20.5439 11 20C11 19.4561 10.5439 19 10 19ZM3 14V20C3 20.5439 3.45614 21 4 21C4.54386 21 5 20.5439 5 20V14C5 13.4561 4.54386 13 4 13C3.45614 13 3 13.4561 3 14ZM9.29825 13.2982L3.29825 19.2982C3.10526 19.4737 3 19.7193 3 20C3 20.5439 3.45614 21 4 21C4.2807 21 4.52632 20.8947 4.70175 20.7018L10.7018 14.7018C10.8947 14.5263 11 14.2807 11 14C11 13.4561 10.5439 13 10 13C9.7193 13 9.47369 13.1053 9.29825 13.2982Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInFull);
export default __webpack_public_path__ + "static/media/open_in_full.4bb9e2b8.svg";
export { ForwardRef as ReactComponent };